// extracted by mini-css-extract-plugin
export var container = "_rg-0";
export var table = "_rg-2";
export var tableWrapper = "_rg-1";